import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
    getAgeCategoryLocalizedName,
    getAgeCategoryLocalizedShortName,
} from '@mews-commander/legacy-entities/src/ducks/ageCategories';
import { ApplicationState } from '@mews-commander/types';

interface StateProps {
    name: string;
    shortName?: string;
}

interface OwnProps {
    id: string;
}

const AgeCategoryName: React.FC<StateProps & OwnProps> = ({ name, shortName }) => <span>{shortName || name}</span>;

export default connect<StateProps, {}, OwnProps, ApplicationState>(
    createStructuredSelector({
        name: getAgeCategoryLocalizedName,
        shortName: getAgeCategoryLocalizedShortName,
    })
)(AgeCategoryName);
